import { useState, useEffect } from 'react'

const MOBILE_SCREEN_WIDTH = 768

const useMobileDetect = () => {
  const [windowWidth, setWindowWidth] = useState(MOBILE_SCREEN_WIDTH)
  useEffect(() => {
    setWindowWidth(window.innerWidth)
    const windowWidthEventListener = () => {
      setWindowWidth(window?.innerWidth)
    }
    window?.addEventListener('resize', windowWidthEventListener)
    return () => {
      window?.removeEventListener('resize', windowWidthEventListener)
    }
  }, [windowWidth])

  const [isMobile, setIsMobile] = useState(true)
  useEffect(() => {
    if (windowWidth < MOBILE_SCREEN_WIDTH) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [windowWidth])

  return isMobile
}

export default useMobileDetect
